import { SectionHeader } from '../Header/SectionHeader';

export function Header(props: { onFilter: (text: string) => void; }) {

    return (
        <>
            <SectionHeader filterProps={{
                placeholder: 'Narrow recent resources...'
            }} onFilter={props.onFilter} />
        </>
    );
}